// Guide Block Types:
// - "section": { id: string, title: string, content: []}
// - "subsection": { title: string, content: [] }
// - "subdivision": { title: string, content: [] }
// - "text": { data: string | () => JSX }
// - "image": { data: string (url) }
// - "gallery": { images: [{ src, alt, credit: { name, url } }] }
// - "table": { data: [ { row: {} }]}
// - "list": { data: string (newline separated list) }
// - "component": { data: string (key to componentMap) }
// - "inlineLink": { text: string, onClick: fn }

import { events } from "../../../data/eventData";

const liveOpsGuide = {
  id: "live-ops",
  title: "Live Ops Guide",
  category: "Guides",
  slug: "live-ops",
  sections: [
    {
      id: "live-ops-summary",
      title: "Summary Page",
      type: "section",
      content: [
        {
          type: "cards",
          data: events,
        },
      ],
    },
    {
      id: "aiveronica",
      title: "AIVeronica",
      type: "section",
      content: [
        {
          type: "component",
          data: "AIVeronica",
        },
      ],
    },{
      id: "neonzone",
      title: "Leon's Neon Zone",
      type: "section",
      content: [
        {
          type: "component",
          data: "NeonZone",
        },
      ],
    },
  ],
};

export default liveOpsGuide;
